if (!customElements.get('videos-products')) {
    customElements.define(
        'videos-products',
        class ProductsShowcase extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                this.enableSlider = this.dataset.enableSlider === 'true';

                if (!this.enableSlider) return;

                this.sectionId = this.dataset.sectionId;
                this.section = this.closest(`.section-${this.sectionId}`);
                this.sliderInstance = false;

                let main_content = document.querySelector('.main-content'),
                    vidmax_wrapper = document.querySelector('.vidmax_wrapper_pro'),
                    vid_small = document.querySelectorAll('.vid_small'),
                    vid_large = document.querySelector('.vid_large'),
                    vidmax = document.querySelector('.vid_large_cont'),
                    vid_la = document.querySelector('.vids_la');

                vid_small.forEach(vid_ => {
                    vid_.addEventListener('click', (e) => {
                        e.preventDefault();
                        vidmax.classList.remove('hide');
                        main_content.classList.add('hide_header');
                        let pos = vid_.dataset.pos;
                        let num = parseInt(pos) - 1;
                        this.initSlider(num);
                        this.play_vid();
                    });
                });

            

            }

            initSlider(slide_to) {
                const spaceBetween = parseInt(this.dataset.itemGap);
                const this_ = this;

                this.sliderOptions = {
                    initialSlide: slide_to,
                    slidesPerView: 1,
                    spaceBetween: spaceBetween,
                    navigation: {
                        nextEl: this.section.querySelector('.swiper-button-next'),
                        prevEl: this.section.querySelector('.swiper-button-prev'),
                    },
                    pagination: {
                        el: this.section.querySelector('.swiper-pagination'),
                        clickable: true,
                        type: 'fraction',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 'auto',
                        },
                    },
                    autoHeight: true,
                    loop: true,
                    threshold: 2,
                };

                this.sliderInstance = new window.FoxTheme.Carousel(this.querySelector('.swiper'), this.sliderOptions);

                let main_content = document.querySelector('.main-content'),
                    vidmax_wrapper = document.querySelector('.vidmax_wrapper_pro'),
                    vid_small = document.querySelectorAll('.vid_small'),
                    vid_large = document.querySelector('.vid_large'),
                    vidmax = document.querySelector('.vid_large_cont'),
                    vid_la = document.querySelector('.vids_la');

                this.sliderInstance.init();

                


                const sliderVideos = this.sliderInstance.slider;

                

                sliderVideos.on('slideChange', function () {
                    this_.play_vid();
                });

                    

                    vidmax.addEventListener("click", function () {
                        vidmax.classList.add('hide');
                        this_.pause_all();
                        main_content.classList.remove('hide_header');
                    }, false);


                    vid_la.addEventListener("click", function (ev) {
                        ev.stopPropagation();
                    }, false);

                    

            }

            play_vid(pos) {
                setTimeout(() => {
                    let vid = document.querySelector('.swiper-slide.swiper-slide-active video');
                    this.pause_all();
                    vid.play();
                  }, 300);
            }

            pause_all() {
                let _vids = document.querySelectorAll('.vid_large_cont video')
                 _vids.forEach(other_ => {
                     other_.pause()
                 });
             }
        }
    );
}
